$(function () {
    if (false && document.location.hostname !== 'pechka.ykt.ru') {
        var isAndroid = (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i));
        var isIos = navigator.userAgent.match(/iPhone/i);
        var isMobile = isAndroid || isIos;
        var isPhoneReg = window.location.href.indexOf("news.ykt.ru")!== -1;
        
        var redirectUrl;
        if (isPhoneReg) {
            if (window.location.href.indexOf("registerPhoneMode")=== -1) {
                if (window.location.href.indexOf("?") ===-1) {
                    redirectUrl = encodeURIComponent(window.location.href + "?registerPhoneMode");
                } else {
                    redirectUrl = encodeURIComponent(window.location.href + "&registerPhoneMode");
                }
            } else {
                redirectUrl = encodeURIComponent(window.location.href);
            }
        } else {
            redirectUrl = encodeURIComponent(window.location.href);
        }
        var socialLinkLinks = [
            {
                codename: 'vk',
                url: '//id.ykt.ru/page/link/vk?returnUrl=' + redirectUrl
            },
            {
                codename: 'fb',
                url: 'https://id.ykt.ru/page/link/fb?returnUrl=' + redirectUrl
            },
            {
                codename: 'ok',
                url: '//id.ykt.ru/page/link/ok?returnUrl=' + redirectUrl
            },
            {
                codename: 'insta',
                url: 'https://id.ykt.ru/page/link/insta?returnUrl=' + redirectUrl
            }
        ];
        var socialAuthLinks = [
            {
                codename: 'vk',
                url: '//id.ykt.ru/page/login/vk?returnUrl=' + redirectUrl
            },
            {
                codename: 'fb',
                url: 'https://id.ykt.ru/page/login/fb?returnUrl=' + redirectUrl
            },
            {
                codename: 'ok',
                url: '//id.ykt.ru/page/login/ok?returnUrl=' + redirectUrl
            },
            {
                codename: 'insta',
                url: 'https://id.ykt.ru/page/login/insta?returnUrl=' + redirectUrl
            }
        ];

        var mainContainer = document.getElementById('y-auth');
        mainContainer.style.display = 'none';
        var fragmentContainer = document.createDocumentFragment();
        var modalContainer = document.createElement('div');
        modalContainer.className = 'remodal y-auth';
        modalContainer.setAttribute('data-remodal-id', 'auth-modal');
        var closeBtn = document.createElement('button');
        closeBtn.className = 'remodal-close';
        closeBtn.setAttribute('data-remodal-action', 'close');
        modalContainer.appendChild(closeBtn);

        var headerAuth = document.createElement('div');
        headerAuth.className = 'y-auth_header auth';
        headerAuth.innerHTML = 'Авторизуйтесь, чтобы оставить комментарий или поставить лайк';
        modalContainer.appendChild(headerAuth);

        var headerVerify = document.createElement('div');
        headerVerify.className = 'y-auth_header verify';
        headerVerify.innerHTML = 'Подтвердите свой профиль, чтобы комментировать или поставить лайк';
        modalContainer.appendChild(headerVerify);

        var body = document.createElement('div');
        body.className = 'y-auth_body';

        var socialContainer = document.createElement('div');
        socialContainer.className = 'y-auth_social';
        var socialHeader = document.createElement('div');
        socialHeader.className = 'y-auth_social_header';
        socialHeader.innerHTML = 'с помощью соцсети';
        socialContainer.appendChild(socialHeader);
        var socialItems = document.createElement('div');
        socialItems.className = 'y-auth_social_items';
        var socialItem;
        socialAuthLinks.forEach(function (item) {
            socialItem = document.createElement('a');
            socialItem.className = 'y-auth_social_item auth ' + item.codename;
            socialItem.href = item.url;
            socialItems.appendChild(socialItem);
        });
        socialLinkLinks.forEach(function (item) {
            socialItem = document.createElement('a');
            socialItem.className = 'y-auth_social_item verify ' + item.codename;
            socialItem.href = item.url;
            socialItems.appendChild(socialItem);
        });
        socialContainer.appendChild(socialItems);
        body.appendChild(socialContainer);

        var formOpenBtn = document.createElement('button');
        formOpenBtn.className = 'yui-btn yui-btn--default y-auth_form-open';
        formOpenBtn.innerHTML = 'или войти с логином';
        body.appendChild(formOpenBtn);

        var verifyLink = document.createElement('a');
        verifyLink.className = 'yui-btn yui-btn--default y-auth_verify-link';
        verifyLink.innerHTML = 'с помощью номера телефона';
        verifyLink.href = '//id.ykt.ru/page/activation?returnUrl=' + redirectUrl + '&change=1';
        if (window.location.host === 'news-stage.ykt.ru') {
            verifyLink.href = '//idtest.ykt.ru/page/activation?returnUrl=' + redirectUrl + '&change=1';
        }
        body.appendChild(verifyLink);

        var fieldset = document.createElement('fieldset');
        fieldset.className = 'y-auth_fieldset';
        fieldset.style.height = '0px';
        var fieldsetLegend = document.createElement('legend');
        fieldsetLegend.className = 'y-auth_fieldset_legend';
        fieldsetLegend.align = 'center';
        fieldsetLegend.innerHTML = 'или войти с логином';
        fieldset.appendChild(fieldsetLegend);

        var form = document.createElement('form');
        form.acceptCharset = 'UTF-8';
        form.method = 'post';
        form.className = 'y-auth_form';
        form.action = '//id.ykt.ru/page/login?return_url=' + redirectUrl;
        var inputGroup = document.createElement('div');
        inputGroup.className = 'y-auth_form_group-input';
        var inputGroupTop = document.createElement('div');
        inputGroupTop.className = 'y-auth_form_group-input_top';
        var inputLogin = document.createElement('input');
        inputLogin.className = 'y-auth_form_input';
        inputLogin.type = 'text';
        inputLogin.name = 'nick';
        inputLogin.id = 'nick';
        inputLogin.placeholder = 'Ник или e-mail';
        inputLogin.required = true;
        inputGroupTop.appendChild(inputLogin);
        inputGroup.appendChild(inputGroupTop);
        var inputGroupBottom = document.createElement('div');
        inputGroupBottom.className = 'y-auth_form_group-input_bottom';
        var inputPassword = document.createElement('input');
        inputPassword.className = 'y-auth_form_input';
        inputPassword.type = 'password';
        inputPassword.name = 'password';
        inputPassword.id = 'password';
        inputPassword.placeholder = 'Пароль';
        inputPassword.required = true;
        inputGroupBottom.appendChild(inputPassword);
        inputGroup.appendChild(inputGroupBottom);
        form.appendChild(inputGroup);
        var formErrors = document.createElement('div');
        formErrors.className = 'y-auth_form_errors';
        form.appendChild(formErrors);
        var submit = document.createElement('button');
        submit.className = 'yui-btn yui-btn--green yui-btn--block y-auth_form_submit';
        submit.type = 'submit';
        submit.innerHTML = 'Войти';
        form.appendChild(submit);
        var formOptions = document.createElement('div');
        formOptions.className = 'y-auth_form_options';
        var remember = document.createElement('div');
        remember.className = 'y-auth_form_remember';
        var rememberLabel = document.createElement('label');
        rememberLabel.className = 'y-auth_form_remember_label';
        var rememberInput = document.createElement('input');
        rememberInput.className = 'y-auth_form_remember_input';
        rememberInput.type = 'checkbox';
        rememberInput.checked = true;
        rememberInput.name = 'remember';
        rememberLabel.appendChild(rememberInput);
        var rememberUI = document.createElement('span');
        rememberUI.className = 'y-auth_form_remember_ui';
        rememberLabel.appendChild(rememberUI);
        var rememberTitle = document.createTextNode(' Запомнить');
        rememberLabel.appendChild(rememberTitle);
        remember.appendChild(rememberLabel);
        formOptions.appendChild(remember);
        var restore = document.createElement('div');
        restore.className = 'y-auth_form_restore';
        var restoreLink = document.createElement('a');
        restoreLink.href= '//id.ykt.ru/page/restore/password';
        restoreLink.innerHTML = 'Забыли пароль?';
        restore.appendChild(restoreLink);
        formOptions.appendChild(restore);
        form.appendChild(formOptions);
        var inputReturnUrl = document.createElement('input');
        inputReturnUrl.type = 'hidden';
        inputReturnUrl.name = 'returnUrl';
        inputReturnUrl.value = redirectUrl;
        form.appendChild(inputReturnUrl);
        var inputToken = document.createElement('input')
        inputToken.type = 'hidden';
        inputToken.name = 'generateAccessToken';
        inputToken.value = 'false';
        form.appendChild(inputToken);
        fieldset.appendChild(form);
        body.appendChild(fieldset);

        var footer = document.createElement('div');
        footer.className = 'y-auth_footer';
        var regLink = document.createElement('a');
        if (isPhoneReg) {
            regLink.href = '//id.ykt.ru/page/register?phoneMode&returnUrl=' + redirectUrl;
        } else {
            regLink.href = '//id.ykt.ru/page/register?returnUrl=' + redirectUrl;
        }
        regLink.innerHTML = 'Регистрация';
        footer.appendChild(regLink);
        body.appendChild(footer);
        modalContainer.appendChild(body);

        fragmentContainer.appendChild(modalContainer);
        mainContainer.appendChild(fragmentContainer);

        (function () {
            formOpenBtn.addEventListener('click', function (ev) {
                this.style.display = 'none';
                fieldset.style.height = '232px';
                fieldset.style.opacity = '1';
            });
        })();

        var remodal = $('[data-remodal-id="auth-modal"]').remodal({
            closeOnOutsideClick: false
            ,hashTracking: false
        });

        function setLinkListener(options) {
            if (options && typeof options.onClickLink === 'function') {
                var socialElements = modalContainer.getElementsByClassName('y-auth_social_item');
                Array.prototype.filter.call(socialElements, function(item) {
                    item.addEventListener('click', options.onClickLink);
                });
                regLink.addEventListener('click', options.onClickLink);
            }
        }

        window.yktAuthModal = {
            openAuth: function (options) {
                modalContainer.classList.remove('verify');
                modalContainer.classList.add('auth');
                setLinkListener(options);
                remodal.open();
            },
            openVerify: function (options) {
                fieldset.style.height = '0px';
                fieldset.style.opacity = '0';
                modalContainer.classList.remove('auth');
                modalContainer.classList.add('verify');
                $(".y-auth_social").hide();
                setLinkListener(options);
                remodal.open();
            }
        };
    }
});